export function format(
  num: number,
  options?: Omit<Intl.NumberFormatOptions, 'style'>,
) {
  return new Intl.NumberFormat('default', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    ...options,
  }).format(num / 100);
}

/**
 * Formatea el input de porcentaje de descuento permitiendo hasta 10 decimales
 * @param value - El valor a formatear
 * @param maxDecimals - Número máximo de decimales permitidos (por defecto 10)
 * @param maxValue - Valor máximo permitido (por defecto 100)
 * @returns El valor formateado
 */
export function formatDiscountPercentageInput(
  value: string,
  maxDecimals: number = 10,
  maxValue: number = 100,
): string {
  // Permitir solo números y un punto decimal
  let cleaned = value.replaceAll(/[^0-9.]/g, '');

  // Evitar múltiples puntos - quedarse solo con el primero
  const firstDotIndex = cleaned.indexOf('.');
  if (firstDotIndex !== -1) {
    cleaned =
      cleaned.slice(0, firstDotIndex + 1) +
      cleaned.slice(firstDotIndex + 1).replaceAll(/\./g, '');
  }

  // Limitar a maxDecimals después del punto
  const parts = cleaned.split('.');
  let formatted = parts[0];
  if (parts.length > 1) {
    formatted += '.' + parts[1].slice(0, maxDecimals);
  }

  // Validar rango - si supera maxValue, limitar a maxValue
  const numValue = Number.parseFloat(formatted);
  if (!Number.isNaN(numValue) && numValue > maxValue) {
    return maxValue.toString();
  }

  return formatted;
}

/**
 * Redondea un porcentaje de descuento a 10 decimales
 * @param value - El valor a redondear
 * @param decimals - Número de decimales (por defecto 10)
 * @returns El valor redondeado
 */
export function roundDiscountPercentage(
  value: number,
  decimals: number = 10,
): number {
  const factor = Math.pow(10, decimals);
  return Math.round(value * factor) / factor;
}
